<div class="header-bar">
  <h1>Supplier Feedback List</h1>
</div>
<div class="content-container">
  <div class="ui-g">
    <div class="ui-g-12">
      <form (ngSubmit)="search()" style="width: 100%">
        <div class="ui-g filterPanel form-group">
          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <span class="md-inputfield filterItem">
              <input
                [(ngModel)]="filterVal.filters.jobNumber.value"
                name="jobnumber"
                pInputText
                type="text"
              />
              <label>Job No</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <p-multiSelect
              [(ngModel)]="filterVal.filters.customerIdList.value"
              [options]="customers"
              [style]="{ width: '100%' }"
              defaultLabel="Customers"
              name="customers"
              styleClass="filterItem"
            ></p-multiSelect>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <p-multiSelect
              [(ngModel)]="filterVal.filters.supplierIdList.value"
              [options]="suppliers"
              [style]="{ width: '100%' }"
              defaultLabel="Suppliers"
              name="suppliers"
              styleClass="filterItem"
            ></p-multiSelect>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <p-dropdown
              [(ngModel)]="filterVal.filters.status.value"
              [options]="statusFeedback"
              [style]="{ width: '100%' }"
              name="statusFeedback"
              styleClass="filterItem"
            ></p-dropdown>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <button
              (click)="clearFilter(dt)"
              class="ui-button btn-to-right"
              label="Clear"
              pButton
              type="button"
            ></button>
            <button class="ui-button btn-to-right" label="Search" pButton type="submit"></button>
          </div>
        </div>
      </form>

      <p-table
        #dt
        (onLazyLoad)="onGridLazyLoad($event)"
        [(selection)]="selectedFeedback"
        [hidden]="!isLoaded"
        [lazy]="true"
        [pageLinks]="3"
        [paginator]="true"
        [responsive]="true"
        [rowsPerPageOptions]="[5, 10, 20]"
        [rows]="10"
        [totalRecords]="page.total"
        [value]="page.items"
        resizableColumns="true"
        rowHover="true"
        selectionMode="single"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="jobNumber">Job No</th>
            <th pSortableColumn="customerName">Customer</th>
            <th pSortableColumn="supplierName">Supplier</th>
            <th pSortableColumn="supplierFeedbackType.description">Feedback</th>
            <th pSortableColumn="lastUpdated">Last Updated</th>
            <th pSortableColumn="status">Status</th>
          </tr>
        </ng-template>

        <ng-template let-feedback pTemplate="body">
          <tr (dblclick)="onFeedbackDetails(feedback)" [pSelectableRow]="feedback">
            <td>
              <span>
                <a
                  href="/app/jobscreen/{{ feedback.jobId }}"
                  target="_blank"
                  title="View the job {{ feedback.jobNumber }}"
                  >{{ feedback.jobNumber }}</a
                ></span
              >
            </td>
            <td>{{ feedback.customerName }}</td>
            <td>{{ feedback.supplierName }}</td>
            <td>{{ feedback.supplierFeedbackType.description }}</td>
            <td>
              <span>{{ feedback.createdOn | date : 'dd/MM/yyyy' }}</span>
            </td>
            <td>
              <span>{{ feedback.resolvedTimeStamp != null ? 'Resolved' : 'Open' }}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DATATABLE DEPRECATED --
              <p-dataTabl #dt [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true"
                           [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" (onRowDblclick)="onFeedbackDetails($event)"
                           [hidden]="!isLoaded" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3" [(selection)]="selectedFeedback"
                           selectionMode="single">
                  <p-column field="jobNumber" header="Job No" [sortable]="true">
                      <ng-template let-col let-feedback="rowData" pTemplate="body">
                          <span>  <a href="/app/jobscreen/{{feedback.jobId}}" target="_blank" title="View the job {{ feedback.jobNumber }}">{{ feedback.jobNumber }}</a></span>
                      </ng-template>
                  </p-column>
                  <p-column field="customerName" header="Customer" [sortable]="true"></p-column>
                  <p-column field="supplierName" header="Supplier" [sortable]="true"></p-column>
                  <p-column field="supplierFeedbackType.description" header="Feedback" [sortable]="true"></p-column>
                  <p-column field="createdOn" header="Created" [sortable]="true">
                      <ng-template let-col let-feedback="rowData" pTemplate="body">
                          <span>{{ feedback[col.field] | date:'dd/MM/yyyy' }}</span>
                      </ng-template>
                  </p-column>
                  <p-column field="lastUpdated" header="Last Updated" [sortable]="true">
                      <ng-template let-col let-feedback="rowData" pTemplate="body">
                          <span>{{ feedback[col.field] | date:'dd/MM/yyyy' }}</span>
                      </ng-template>
                  </p-column>
                  <p-column field="status" header="Status" [sortable]="true">
                      <ng-template let-col let-feedback="rowData" pTemplate="body">
                          <span>{{ feedback.resolvedTimeStamp != null ? "Resolved" : "Open" }}</span>
                      </ng-template>
                  </p-column>
              </p-dataTable>
              -->
    </div>
    <div class="ui-g-12" style="height: 40px; margin-top: 20px">
      <button
        (click)="openFeedback(selectedFeedback.id)"
        [disabled]="!selectedFeedback"
        class="ui-button btn-to-right"
        icon="fa ui-icon-edit"
        label="Edit"
        pButton
        type="button"
      ></button>
      <button
        (click)="downloadToCSV()"
        class="btn-to-right"
        label="Download to CSV"
        pButton
        type="button"
      ></button>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
